import { Inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { last, tap } from 'rxjs/operators';

import { APP_CONFIG } from '../config/app-config.service';
import { IAppConfig } from '../config/app-config.model';
import { BookingResponseBase } from './booking-api-responses.interface';
import { AuthService } from './auth.service';
import { IS_SKIP_HANDLE_ERROR } from './api-http-context-token';
import { LogService } from '../log.service';
import { UiService } from '../ui.service';

@Injectable()
export class ApIErrorInterceptor implements HttpInterceptor {
    public constructor(
      @Inject(APP_CONFIG) protected config: IAppConfig,
      private auth: AuthService,
      private log: LogService,
      private ui: UiService,
    ){
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {      
      return next.handle(req).pipe(last((res) => {
        if(res.type === 4){
          const body: BookingResponseBase = res.body;
          if(body){
            if(!body.success && body.errors && body.errors.length){
              const errorCode = body.errors[0].code;

              const errorSummary = this.config.hideErrorCodeInFailureApiMessage ? 'Error' : `Error ${errorCode}`;

              if(req.context?.get(IS_SKIP_HANDLE_ERROR) === true){
                return true
              }
              
              const desc = body.errors[0].description;

              // If error code starts with BS or DS => show code + "common.error.general"
              // DS0701: Reset password code is expired.
              if(!desc){
                this.ui.toastErrorT('common.error.general', {summary: errorSummary});
                return true;
              }

              this.ui.toastError(desc, {summary: errorSummary, duration: 5000});

              // Invalid token
              if(errorCode === 'XWAPI202' && this.config.isUsingExternalIdentityServer){
                // logout from keycloak
                setTimeout(() => {
                  this.auth.forceLogoutFromKeycloak();
                }, 3000);
              }
            }
          }
        }
        return true;
      }),
      tap({
        error: (err: any) => {
          if(req.context?.get(IS_SKIP_HANDLE_ERROR) === true){
            if(err){
              (err as any).handled = true;
            }
            return
          }

          this.log.log(`ApIErrorInterceptor error: ${JSON.stringify(err)}, status=${err?.status}, abort=${err?.error?.type}`);
          if (err instanceof HttpErrorResponse) {
            if(err.status === 306){
              // mark this error handled
              (err as any).handled = true;
              this.log.log(`Ignore duplicate request ${req.url}. Status code: ${err.status}`);
            }
            else if (err.status === 409) {
              // mark this error handled
              (err as any).handled = true;

              this.auth.show409Error();

              setTimeout(() => {
                this.auth.logout(true);
              }, 3000);
            }
            else if(err.status === 401){
              // token is invalid, force logout
              this.auth.showSessionExpiredMessage();
              setTimeout(() => {
                this.auth.logout(true);
              }, 3000);
            }
          }
        }
      }));
    }
}